import { themeColors } from "../../utils/constants";

export const CACHE_KEY = "xtwitter:pulledTweets";
export const KEYWORD_LIST_CONFIG = "x_search_keywords";
export const KEYWORD_SUFFIX_CONFIG = "x_search_suffix";
export const LEGACY_QUERY_CONFIG = "x_search_query";
export const MIN_FOLLOWER_CONFIG = "x_min_follower_count";
export const DEFAULT_SUFFIX = "lang:en -is:retweet -is:reply";

export const textFieldStyles = {
  "& .MuiInputBase-input": { color: themeColors.color },
  "& .MuiFormLabel-root": { color: themeColors.color },
  "& .MuiOutlinedInput-root": {
    color: themeColors.color,
    "& fieldset": { borderColor: themeColors.color },
    "&:hover fieldset": { borderColor: themeColors.color },
    "&.Mui-focused fieldset": { borderColor: themeColors.color },
  },
};

export const gqlFetch = async (query, variables) => {
  const res = await fetch("/graphql", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query, variables }),
  });
  const json = await res.json();
  if (json.errors) throw new Error(json.errors.map((e) => e.message).join("; "));
  return json.data;
};

export function readCachedRows() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn("Failed to read cached tweets", err);
    try {
      window.localStorage.removeItem(CACHE_KEY);
    } catch (cleanupErr) {
      console.warn("Failed to remove corrupt tweet cache", cleanupErr);
    }
    return [];
  }
}

export function persistRows(rowsToSave) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify(rowsToSave));
  } catch (err) {
    console.warn("Failed to persist tweets cache", err);
  }
}

export function normalizeKeyword(value) {
  return (value || "").trim().replace(/\s+/g, " ").toUpperCase();
}

export function parseKeywordsFromConfig(keywordValue, legacyValue) {
  if (keywordValue) {
    try {
      const parsed = JSON.parse(keywordValue);
      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => normalizeKeyword(String(item || "")))
          .filter(Boolean);
      }
    } catch (err) {
      // ignore JSON parsing failures
    }
  }
  const legacy = deriveLegacyParts(legacyValue);
  if (legacy.keywordsText) {
    return legacy.keywordsText
      .split(/OR|,|\|/i)
      .map((part) =>
        normalizeKeyword(part.replace(/^[()\s]+|[()\s]+$/g, ""))
      )
      .filter(Boolean);
  }
  return [];
}

export function parseSuffixFromConfig(suffixValue, legacyValue) {
  if (suffixValue && suffixValue.trim().length > 0) {
    return suffixValue.trim();
  }
  const legacy = deriveLegacyParts(legacyValue);
  if (legacy.suffixText) return legacy.suffixText;
  return DEFAULT_SUFFIX;
}

function deriveLegacyParts(raw) {
  if (!raw) return { keywordsText: "", suffixText: "" };
  try {
    const match = raw.match(/^\s*\(([^)]+)\)\s*(.*)$/);
    if (match) {
      return {
        keywordsText: match[1] || "",
        suffixText: (match[2] || "").trim(),
      };
    }
  } catch (err) {
    // ignore parsing issues and fall back
  }
  return { keywordsText: raw, suffixText: "" };
}
